import React, { useEffect, useMemo, useState } from 'react';
import './LandingPage.scss';
import { Icon, Modal, Popup, Progress, VerticalMenu } from '@scuf/common';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from 'src/constants/routeConstants';
import { isAks } from 'src/utils/properties/UrlsAndEnvProperties';
import { getUserInfo } from 'src/slices/userProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getMessage } from 'src/message/utils';
import { UserManager } from '@forge/sso-client';
import keycloak from 'src/router/keycloak';
import {
  getCurrentModel,
  getLandOpportunity,
  opportunitiesList,
  setCurrentModel,
  getModallabelDataValue,
  getModelLabelData
} from 'src/slices/landlinePageSlice';
import {
  modelTableauDetails,
  setCurrentUniqueId
} from 'src/slices/contextSlice';
import { getCurrentRole } from 'src/slices/onBoardingSlice';
import moment from 'moment';
import FeedbackCard from 'src/components/FeedbackCard/FeedbackCard';
import { USER_ROLE } from 'src/constants/constants';
import { DataContextModal } from 'src/components/DataContextModal/DataContextModal';
import { TabList } from './TabList';
import Ribbon from 'src/components/Ribbon/Ribbon';
import SystemProperty from 'src/utils/properties/SystemProperty';
import ScrollingText from 'src/components/ScrollingText/ScrollingText';
import { getuiMessages } from "src/services/Profiles";
import { shouldDisplayMessage } from 'src/utils/general/EnvCheck';

const LargeCard = ({
  icon,
  insight_id,
  insight_summary_display_category: header,
  assigned_date,
  org_user,
  onClick = () => false,
}: any) => {
  return (
    <div className='large-card-container' onClick={onClick}>
      <div className='card-top'>
        <div className='card-top-left'>
          <div className='card-id'>{insight_id}</div>
          <Icon className='card-icon' root='common' name={icon} size='large' />
        </div>
        <div className='card-top-right'>
          <div className='card-header'>{header}</div>
          <div className='card-date'>Assigned Date: {assigned_date}</div>
        </div>
      </div>
      <div className='card-bottom'>Org Owner: {org_user}</div>
    </div>
  );
};

const LargeCardModel = (props: any) => {
  return (
    <div className='large-card-container' onClick={() => props.handleClick1(props.modelId, props.uniqueId, props.modelStage, props.modelName)}>
      <div className='card-top'>
        <div className='card-top-left'>
          <div className='card-id'>{props.modelId}</div>
          {/* <Icon className='card-icon' root='common' name={icon} size='large' /> */}
        </div>
        <div className='card-top-right'>
          <div className='card-header'>{props.modelName}</div>
          <div className='card-date'>Model Stage: {props.modelStage}</div>
        </div>
      </div>
      {/* <div className='card-bottom'>Org Owner: {org_user}</div> */}
    </div>
  );
};

const LandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userManager = UserManager.getInstance();
  const { eid, name } = useSelector(getUserInfo);
  const currentRole = useSelector(getCurrentRole);
  const { loading, opportunity_detail } = useSelector(getLandOpportunity);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const currentModel = useSelector(getCurrentModel);
  const [currentModelHeader, setCurrentModalHeader] = useState("");
  const [currentUniqueIdValue, setCurrentUniqueIdValue] = useState("");
  const [currentStatgeId, setCurrentStatgeId] = useState(0);
  const [currentModelId, setCurrentModelId] = useState(0);
  const [gametimePopUp, setGametimePopUp] = useState(false);
  const [scrollingMessage, setscrollingMessage] = useState<ScrollingMessage[]>([]);
  const [flashingMessage, setFlashingMessage] = useState<FlashingMessage[]>([]);

  const model_details = useSelector(getModallabelDataValue);
  const manageProfile: string = getMessage('app.header.menu.profile');
  const controlCenter: string = getMessage('app.header.menu.controlcenter');
  const signOut: string = getMessage('app.header.menu.signout');
  const help: string = getMessage('app.header.menu.help');

  interface ScrollingMessageParameters {
    scrollCount?: string;
    scrollingSpeed?: string;
    textColor?: string;
    borderColor?: string;
    backgroundColor?: string;
  }

  interface ScrollingMessage {
    id: number;
    role_id: number;
    text_message: string;
    text_environment: string;
    display_message: string;
    message_parameters?: ScrollingMessageParameters;
    message_type: string;
  }

  interface FlashingMessageParameters {
    textColor?: string;
    borderColor?: string;
    backgroundColor?: string;
    flashCount?: string;
  }

  interface FlashingMessage {
    id: number;
    role_id: number;
    text_message: string;
    text_environment: string;
    display_message: string;
    message_parameters?: FlashingMessageParameters;
    message_type: string;
  }

  const DataListMapped = useMemo(
    () =>
      opportunity_detail.map((data: any) => ({
        ...data,
        icon: 'search',
        assigned_date: moment(data.assigned_date).format('DD/MM/yyyy'),
        onClick: () => {
          navigate(
            RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH + '/' + data.insight_id
          );
          dispatch(setCurrentModel(data.insight_id))
        }
      })),
    [navigate, opportunity_detail, dispatch]
  );

  const navigateToControlCenter = () => {
    let hostName = window.location.hostname;
    if (hostName.includes('cam.hia')) {
      window.open('https://rbac.hia.honeywell.com', '_blank', 'noopener,noreferrer');
    } else if (hostName.includes('-dev')) {
      window.open('https://rbac-dev.hia.honeywell.com', '_blank', 'noopener,noreferrer');
    } else if (hostName.includes('-qa')) {
      window.open('https://rbac-qa.hia.honeywell.com', '_blank', 'noopener,noreferrer');
    }
  };

  const handleLogout = () => {
    isAks() ? keycloak.logout() : userManager.signoutRedirect();
  };

  const getFilters = (currentRole: string) => {
    switch (currentRole) {
      case USER_ROLE.REVIEWER: {
        return [
          {
            column: 'insight_display_status',
            type: 'in',
            value: ['unreviewed'],
          },
        ];
      }
      case USER_ROLE.ORG_USER: {
        return [
          {
            column: 'insight_display_status',
            type: 'in',
            value: ['reviewed-awaiting_org_owner_approval'],
          },
        ];
      }
      default: {
        return [];
      }
    }
  };

  useEffect(() => {
    if (currentRole) {
      const filters = getFilters(currentRole);
      dispatch(opportunitiesList({ current_role: currentRole, filters }));
      dispatch(getModelLabelData({}));
    }
  }, [dispatch, currentRole]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getuiMessages();
        if (data && data.func_get_ui_messages) {
          setscrollingMessage(data.func_get_ui_messages.filter((message: { id: number; }) => message.id === 1));
          setFlashingMessage(data.func_get_ui_messages.filter((message: { id: number; }) => message.id === 2));
        } else {
          console.log("No data received or func_get_ui_messages is missing");
        }
      } catch (error) {
        console.error("getuiMessages error:", error);
      }
    };
    fetchData();
  }, []);

  const handleModelClick = (modelId: any, uniqueId: any, modelStage: any, modelName: any) => {
    setCurrentModalHeader(modelName);
    setCurrentModelId(modelId);
    setCurrentStatgeId(modelStage);
    setCurrentUniqueIdValue(uniqueId);
    setGametimePopUp(true);
    dispatch(
      modelTableauDetails({
        unique_id: uniqueId,
        model_id: modelId,
        stage_id: modelStage,
      })
    );
    dispatch(setCurrentUniqueId(uniqueId));
  }

  const handleClose = () => {
    setGametimePopUp(false);
  }

  return (
    <>
      <div>
        {scrollingMessage.map((scrolling_message: ScrollingMessage) => {
          const {
            backgroundColor = 'defaultColor',
            borderColor = 'defaultColor',
            textColor = 'defaultColor',
            scrollingSpeed = '7s',
            scrollCount = '1',
          } = scrolling_message.message_parameters || {};

          return (
            <ScrollingText
              key={scrolling_message.id}
              backgroundColor={backgroundColor}
              borderColor={borderColor}
              textColor={textColor}
              scrollingSpeed={scrollingSpeed}
              scrollCount={parseInt(scrollCount)}
              display={shouldDisplayMessage(scrolling_message.text_environment, scrolling_message.display_message)}
            >
              {scrolling_message.text_message}
            </ScrollingText>
          );
        })}
      </div>

      <div>
        {flashingMessage.map((flashing_message: FlashingMessage) => {
          const { backgroundColor = "defaultColor", borderColor = "defaultColor", textColor = "defaultColor", flashCount = "3" } = flashing_message.message_parameters || {};
          return (
            <Ribbon
              key={flashing_message.id}
              backgroundColor={backgroundColor}
              borderColor={borderColor}
              textColor={textColor}
              flashCount={parseInt(flashCount)}
              display={shouldDisplayMessage(flashing_message.text_environment, flashing_message.display_message)}
              text={flashing_message.text_message}
            />
          );
        })}
      </div>

      <div className='land-container'>
        {
          console.log("model_details  ss", model_details)
        }
        <div className='left-container'>
          {/* Your existing left-container content */}
          <TabList role={currentRole} />
        </div>
        <div className='right-container'>
          <div className='powered-by'> </div>
          <div className='large-card-list'>
            {
              (model_details.model_details.length > 0 || DataListMapped.length > 0) && <div className='headings'>
                Top 3 Anomalies and Models
              </div>
            }

            {
              model_details.model_details.map((data: any) => (
                <LargeCardModel
                  key={data.model_id} // Adding a unique key
                  modelId={data.model_id}
                  handleClick1={handleModelClick}
                  modelStage={data.model_stage}
                  uniqueId={data.unique_id}
                  modelName={data.model_name}
                />
              ))
            }
            {!loading &&
              DataListMapped.map(({ id: insight_id, ...props }: any) => (
                <LargeCard key={insight_id} {...{ insight_id, ...props }} />
              ))}

            {loading && (
              <div className='large-card-loader'>
                <Progress circular size='medium' />
              </div>
            )}
          </div>
        </div>
        <Modal open={feedbackModal} className='land-feedback-modal'>
          <FeedbackCard onClose={() => setFeedbackModal(false)} />
        </Modal>

        {gametimePopUp && (
          <div>
            <DataContextModal
              open={true}
              onClose={handleClose}
              modalHeader={currentModelHeader ?? ''}
              uniqueId={currentUniqueIdValue ?? null}
              statgeId={currentStatgeId ?? null}
              modelId={currentModelId ?? null}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LandingPage;
